var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_36_23312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5178 42.5193C70.5177 42.5192 70.5175 42.5192 70.5175 42.5194C70.4998 43.6148 70.1857 44.456 69.5488 45.139C68.5459 46.2143 67.5128 47.2626 66.474 48.3033C61.9089 52.8772 57.3406 57.4486 52.7616 62.0087C52.3107 62.4578 51.8086 62.8728 51.2757 63.2197C49.9354 64.0907 48.592 64.0541 47.3236 63.0702C46.5554 62.4742 45.8534 61.7861 45.1622 61.0986C43.2631 59.209 41.3703 57.3118 39.5046 55.3894C38.498 54.3525 37.996 53.1062 38.3611 51.6473C38.8809 49.5691 41.1205 48.1368 43.4353 49.2411C43.9562 49.4896 44.4494 49.8485 44.8689 50.2471C46.2773 51.5861 47.6472 52.9662 49.0316 54.3304C49.3551 54.6495 49.398 54.6489 49.7109 54.3367C53.4472 50.6129 57.1804 46.8867 60.9225 43.1692C62.0697 42.0295 63.1994 40.8652 64.4166 39.8031C65.6024 38.7681 67.0095 38.6376 68.4274 39.2992C69.8337 39.955 70.4348 41.1658 70.5181 42.5191C70.5182 42.5193 70.518 42.5194 70.5178 42.5193Z",
    fill: "url(#paint0_linear_36_23312)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_36_23312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.615 50.5465C12.6154 50.5463 12.6156 50.5459 12.6156 50.5454C12.5842 43.6085 14.0765 37.3766 17.0761 31.5093C19.0319 27.684 21.5321 24.2478 24.5425 21.1782C27.3271 18.3393 30.4384 15.9275 33.8846 13.9489C38.6863 11.192 43.8323 9.43046 49.3182 8.67107C51.8222 8.32418 54.34 8.19993 56.8641 8.31093C62.5923 8.56259 68.0549 9.89719 73.2305 12.3784C77.6802 14.5121 81.638 17.339 85.0873 20.8653C90.0517 25.9401 93.5503 31.8833 95.5818 38.6893C96.4989 41.7616 97.0495 44.8962 97.281 48.0927C97.73 54.2926 96.8268 60.2863 94.5531 66.0681C92.8704 70.3468 90.5304 74.239 87.5692 77.7571C83.4519 82.6477 78.4957 86.4477 72.7026 89.1478C68.9757 90.8848 65.0729 92.0441 60.9991 92.6306C58.4012 93.0046 55.7919 93.1434 53.1725 93.0292C47.9256 92.8009 42.8818 91.6669 38.0612 89.5666C33.3094 87.4966 29.0779 84.6521 25.3738 81.0261C21.3435 77.081 18.2208 72.5146 16.0127 67.3238C14.487 63.7363 13.474 60.0107 12.9808 56.1425C12.7292 54.1699 12.5999 52.1922 12.6144 50.5475C12.6144 50.5471 12.6146 50.5467 12.615 50.5465ZM55.1359 85.5767C55.1359 85.5771 55.1362 85.5773 55.1366 85.5773C57.9273 85.5931 60.6726 85.2436 63.3718 84.5575C67.7074 83.4562 71.6796 81.5717 75.2974 78.9422C80.2302 75.3572 84.0517 70.835 86.678 65.327C88.9738 60.5115 90.0574 55.4355 89.848 50.092C89.7452 47.4689 89.392 44.8823 88.7348 42.3418C87.0634 35.877 83.8802 30.2775 79.1031 25.5969C76.2769 22.8281 73.0691 20.6099 69.4759 18.953C64.6541 16.7297 59.5863 15.6991 54.2782 15.8291C51.5995 15.8947 48.9625 16.2479 46.3671 16.9107C40.9997 18.2825 36.2265 20.7947 32.0499 24.4276C28.5191 27.4992 25.7118 31.1378 23.633 35.3339C21.7907 39.0533 20.661 42.9776 20.2586 47.1075C20.012 49.636 20.0663 52.1633 20.3627 54.6868C20.7954 58.3658 21.7598 61.8952 23.3094 65.2607C25.9496 70.9946 29.8569 75.6808 35.0382 79.2803C41.074 83.4732 47.7991 85.5129 55.1353 85.5761C55.1357 85.5761 55.1359 85.5764 55.1359 85.5767Z",
    fill: "url(#paint1_linear_36_23312)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_36_23312",
    x: 26.2422,
    y: 30.8926,
    width: 56.2759,
    height: 48.9497,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_23312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36_23312",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_36_23312",
    x: 0.613281,
    y: 0.271484,
    width: 108.779,
    height: 108.796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.627451 0 0 0 0 0.639216 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_23312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36_23312",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_23312",
    x1: 35.012,
    y1: 31.0348,
    x2: 80.3199,
    y2: 35.5679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3295BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A78C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36_23312",
    x1: 4.12862,
    y1: -18.4347,
    x2: 123.616,
    y2: -9.19533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3295BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33A78C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.59b2826d1223eaad6f2055fbd00adfe8.svg";
export { ForwardRef as ReactComponent };